import { Component } from 'react';
import ViewModel from '../../viewmodel';
import { getParentWindow, getTopWindow } from '../../window.js';
import { getRunContext } from '../../qiankunContext.js';
import { getGlobalStorage } from '../../storage';
// import { AnimationFrameScheduler } from 'rxjs/internal/scheduler/AnimationFrameScheduler';
/*
* autor:张建新  zjx@yonyou.com   
* date: 2018/07/17
* ClientMonitor for App,render count etc.
* useage: 

* modify 陈道诚 chendch@yonyou.com 
* date 2020/6/8
*/
const _monitorDataPath = 'monitro.ui.data';
class ClientMonitor extends Component {
    constructor(props) {
        super(props);
        this.ViewModel = ViewModel;
        this._page = null;
        this.pageName = '';
        this.firstStartTime = null;
        this.flag_Monitor = 'sys_flag_bmonitor';
        this.isFirst = true;
    }

	reset = () => {
	    getTopWindow().monitorDataTotal = {};
	    getTopWindow().monitorDataTotal.countNumber = [];
	    getTopWindow().monitorDataTotal.count = 0;
	    getTopWindow().monitorDataTotal.pageComponent = [];
	    getTopWindow().monitorDataTotal.startRenderTime = new Date();
	};
	getMonitorData = () => {
	    if (this._page && this._page.refs && this._page.refs.monitorpage) {
	        return this._page.refs.monitorpage.props.ViewModel.getData(this.getCurrentNamespace(this.pageName));
	    } else {
	        return { WARINING: '监控异常，请刷新页面重试' };
	    }
	};
	getbMonitor = () => {
	    let v = false;
	    try {
	        v = JSON.parse(sessionStorage.getItem(this.flag_Monitor));
	        if (v == null) {
	            v = false;
	        }
	    } catch (ex) {
	        v = false;
	    }
	    return v;
	};
	endMonitor = () => {
	    if (!this.getbMonitor()) {

	        return { WARINING: '监控没有开启，请开启 getTopWindow().sys_monitor.startMonitor()' };
	    }
	    sessionStorage.setItem(this.flag_Monitor, false);
	    let result = getTopWindow().monitorDataTotal ? JSON.stringify(getTopWindow().monitorDataTotal) :
	        JSON.stringify({ count: 0, countNumber: [], pageComponent: [] });
	    this.reset();
	    return result;
	};
	getCurrentNamespace = name => {
	    return _monitorDataPath + '.' + name;
	};
	startMonitor = () => {
	    sessionStorage.setItem(this.flag_Monitor, true);
	    return true;
	};

	initMonitor = (page, init = true) => {
	    this._page = page;
	    this.reset();
		
	    if (page && page.refs && page.refs.monitorpage) {
	        let mp = page.refs.monitorpage;
	        this.mpCopy = page.refs.monitorpage;
	        this.pageName = mp.constructor.name;
	        //
	        if (init) { this.reset(); }

	        if (this.isFirst) {
	            this.isFirst = false;
	            this.cwcC = this.cwcC || mp.componentWillUpdate;
	            mp.componentWillUpdate = this.componentWillUpdateC.bind(this, mp);
	            //getTopWindow().monitorDataTotal._cwcC = cwcC;
	            //
	            this.cwmC = this.cwmC || mp.componentWillMount;
	            mp.componentWillMount = this.componentWillMountC.bind(this, mp);
	            //getTopWindow().monitorDataTotal._cwmC = cwmC;
	            //
	            this.cdmC = this.cdmC || mp.componentDidMount;
	            mp.componentDidMount = this.componentDidMountC.bind(this, mp);
	            //getTopWindow().monitorDataTotal._cdmC = cdmC;
	            //
	            this.cduC = this.cduC || mp.componentDidUpdate;
	            mp.componentDidUpdate = this.componentDidUpdateC.bind(this, mp);
	            //getTopWindow().monitorDataTotal._cudC = cduC;
	        }
			
	        let d = this.getMonitorData();
	        if (d && d._rC) { return; }
	        //
	        let rC = mp.render;
	        //mp.render = this.renderC;
	        getTopWindow().monitorDataTotal._rC = rC;
	        mp.props.ViewModel.setData(this.getCurrentNamespace(this.pageName), getTopWindow().monitorDataTotal);
	    }
	};

	componentWillMountC = function (mp, ...rest) {
	    let currenNamespace = _monitorDataPath + '.' + mp.constructor.name;
	    let monitorData = mp.props.ViewModel.getData(currenNamespace);
	    //let isInsideTab = JSON.parse(getGlobalStorage('localStorage', 'INSIDE_TAB'));
	    if(window != getTopWindow()){
	        getTopWindow().monitorDataTotal.startRenderTime = new Date();
	    }
	    if (this.cwmC) {
	        return this.cwmC.bind(mp)(...rest);
	    }
		
	}

	componentDidMountC = function (mp, ...rest) {
	    let currenNamespace = _monitorDataPath + '.' + mp.constructor.name;
	    let monitorData = mp.props.ViewModel.getData(currenNamespace);
	    // 无iframe时，工作桌面更新不能更新渲染次数
	    //let isInsideTab = JSON.parse(getGlobalStorage('localStorage', 'INSIDE_TAB'));
	    if(window != getTopWindow()){
	        let endRenderTime = new Date();
	        let cost = (endRenderTime.getTime() - getTopWindow().monitorDataTotal.startRenderTime.getTime()) / 1000;
	        getTopWindow().monitorDataTotal.countNumber[getTopWindow().monitorDataTotal.count] = '第' + getTopWindow().monitorDataTotal.count + '次渲染耗时：' + cost + '秒';
	        getTopWindow().monitorDataTotal.count++;
	        getTopWindow().monitorDataTotal.endRenderTime = endRenderTime;
	    }
		
	    if (this.cdmC) {
	        return this.cdmC.bind(mp)(...rest);
	    }
		
	}

	componentWillUpdateC = function (mp, ...rest) {
	    console.log('---monitor:' + mp.constructor.name + 'react脏数据已对比完成，准备开始更新---');
	    // let currenNamespace = _monitorDataPath + '.' + this.constructor.name;
	    // let monitorData = this.props.ViewModel.getData(currenNamespace);
	    //let isInsideTab = JSON.parse(getGlobalStorage('localStorage', 'INSIDE_TAB'));
	    if(window != getTopWindow()){
	        getTopWindow().monitorDataTotal.startRenderTime = new Date();
	    }
		
	    if (this.cwcC) {
	        return this.cwcC.bind(mp)(...rest);
	    }
		
	}

	componentDidUpdateC = function (mp, ...rest) {
	    console.log('---monitor:' + mp.constructor.name + '组件更新及dom节点更新完毕---');
	    let currenNamespace = _monitorDataPath + '.' + mp.constructor.name;
	    let monitorData = mp.props.ViewModel.getData(currenNamespace);
	    let notNeedMonitor = ViewModel.getData('notNeedMonitor');
	    //let isInsideTab = JSON.parse(getGlobalStorage('localStorage', 'INSIDE_TAB'));
	    if (!notNeedMonitor && window != getTopWindow()) {
	        let endRenderTime = new Date();
	        let cost = (endRenderTime.getTime() - getTopWindow().monitorDataTotal.startRenderTime.getTime()) / 1000;
	        getTopWindow().monitorDataTotal.countNumber[getTopWindow().monitorDataTotal.count] = '第' + getTopWindow().monitorDataTotal.count + '次渲染耗时：' + cost + '秒';
	        getTopWindow().monitorDataTotal.count++;
	        getTopWindow().monitorDataTotal.endRenderTime = endRenderTime;
	    }
	    //
	    if (this.cduC) {
	        return this.cduC.bind(mp)(...rest);
	    }
		
	};
	renderC = function () {
	    let isInsideTab = JSON.parse(getGlobalStorage('localStorage', 'INSIDE_TAB'));
	    if(!isInsideTab){
	        let currenNamespace = _monitorDataPath + '.' + this.constructor.name;
	        let monitorData = this.props.ViewModel.getData(currenNamespace);
	        if (!getTopWindow().monitorDataTotal) { getTopWindow().monitorDataTotal = {}; }
	        console.log('---monitor:组件' + this.constructor.name + '开始render---');
	        if (monitorData && monitorData._rC && monitorData._rC.bind) {
	            return monitorData._rC.bind(this)();
	        }else{
	            return null;
	        }
	    }
		
	};
}
//getTopWindow().sys_monitor = new ClientMonitor();
export default ClientMonitor;
